import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'sc-field-template',
  templateUrl: './field-template.component.html',
  styleUrls: ['./field-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldTemplateComponent extends FieldType implements OnInit {
  @ViewChild('content', { static: true, read: ViewContainerRef })
  content: ViewContainerRef;
  public componentRef: ComponentRef<FieldTemplateComponent>;
  public templateKey: string;

  constructor(private _cfr: ComponentFactoryResolver, private _cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.templateKey = this.field.key ? `template-${this.field.key}` : '';
    const cmpFactory: any = this._cfr.resolveComponentFactory(this.field.templateOptions.templateRef);
    this.componentRef = this.content.createComponent(cmpFactory);
    this.componentRef.changeDetectorRef.markForCheck();
    this.componentRef.instance['field'] = this.field;
    if (this.field.templateOptions.inputs) {
      this.field.templateOptions.inputs.forEach(input => {
        this.componentRef.instance[input.key] = input.value;
      });
    }
    this._cd.markForCheck();
  }
}
